require("./bootstrap")
require("./components/analytics")
require("./components/colissimo-relay")
require("./components/sliders")
require("./components/product-zoom")
require("./components/products-filters")
require("./components/sliders")

Livewire.onPageExpired(function () {
    if (confirm("La page a expiré.\nVoulez-vous recharger ?")) {
        window.location.reload()
    }
})
